import { ProductUnitCategory } from '../enums/productUnitCategory'

export const productUnitCategoryToTranslationKey: Record<ProductUnitCategory, string> = {
  [ProductUnitCategory.Custom]: 'products.units.category.custom',
  [ProductUnitCategory.Length]: 'products.units.category.length',
  [ProductUnitCategory.Packaging]: 'products.units.category.packaging',
  [ProductUnitCategory.Quantity]: 'products.units.category.quantity',
  [ProductUnitCategory.ServiceAndTime]: 'products.units.category.service_time',
  [ProductUnitCategory.VolumeAndArea]: 'products.units.category.volume_area',
  [ProductUnitCategory.Weight]: 'products.units.category.weight',
}

// Display order of the standard categories in the unit select and the units modal
export const standardProductUnitCategories = [
  ProductUnitCategory.Quantity,
  ProductUnitCategory.ServiceAndTime,
  ProductUnitCategory.Weight,
  ProductUnitCategory.VolumeAndArea,
  ProductUnitCategory.Length,
  ProductUnitCategory.Packaging,
]

export const productUnitSelectCategories = [...standardProductUnitCategories, ProductUnitCategory.Custom]

export const productUnitModalCategories = [ProductUnitCategory.Custom, ...standardProductUnitCategories]
